<script setup lang="ts">
import type { TooltipEmits, TooltipProps, TooltipSlots } from '#ui/types';
import { useForwardPropsEmits } from 'reka-ui';
import { computed } from 'vue';
import Tooltip from '#ui/components/Tooltip.vue';

const { kbds: kbdsProp, ...forwardedProps } = defineProps<TooltipProps>();
const emits = defineEmits<TooltipEmits>();
const slots = defineSlots<TooltipSlots>();

const forward = useForwardPropsEmits(forwardedProps, emits);
const kbds = computed<TooltipProps['kbds']>(() =>
	kbdsProp?.map((kbd) => ({
		variant: 'solid',
		...(typeof kbd === 'string' ? { value: kbd } : kbd),
	})) as TooltipProps['kbds'],
);
</script>

<template>
	<Tooltip v-bind="forward" :kbds>
		<template v-for="(_, name) in slots" #[name]="slotData: any">
			<slot :name v-bind="slotData" />
		</template>
	</Tooltip>
</template>
